<template>
    <section id="pricing" class="section-padding init">
        <div class="container">
            <div class="section-header text-center">
                <h2 class="section-title wow fadeInDown" data-wow-delay="0.3s">CARF <br>“{{$t('carf.title')}}”</h2>
                <h2 class="wow fadeIn" data-wow-delay="0.4s">
                    <img width="180px" src="../assets/img/carf-certified.svg" alt="">
                </h2>
                <h4 class="section-title wow fadeInDown" data-wow-delay="0.5s">“{{$t('carf.subtitle')}}”</h4>
                <div style="margin-bottom: 10px" class="shape wow fadeInDown" data-wow-delay="0.5s"></div>
                <p class="wow fadeInDown" data-wow-delay="0.6s">“{{$t('carf.description')}}”</p>

            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6 col-xs-12 ">
                    <div class="table wow fadeInLeft"  data-wow-delay="1.2s">
                        <div class="icon-box">
                            <i class="lni-medall-alt"></i>
                        </div>
                        <div class="title">
                            <h3>{{$t('carf.txt1')}}</h3>
                        </div>
                        <a target="_blank" href="http://carf.org/Providers/" class="btn btn-common">{{$t('see')}}</a>

                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="table wow  fadeInUp" data-wow-delay="1.2s">
                        <div class="icon-box">
                            <i style="font-size: 55px;" class="lni-medall"></i>
                        </div>
                        <div class="title">
                            <h3>{{$t('carf.txt2')}}</h3>
                        </div>
                        <a target="_blank" href="http://carf.org/Accreditation/WhyCARF/" class="btn btn-common">{{$t('see')}}</a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="table wow fadeInRight" data-wow-delay="1.2s">
                        <div class="icon-box">
                            <i class="lni-medall-alt"></i>
                        </div>
                        <div class="title">
                            <h3>{{$t('carf.txt3')}}</h3>
                        </div>
                        <a target="_blank" href=" http://carf.org/Public/" class="btn btn-common">{{$t('see')}}</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Carf"
    }
</script>

<style lang="scss">
h4.section-title{
    font-size: 1.5em;
    color: $primary-color;
}
</style>
